import actions from './actions';

const initState = {
    data: []
};

export default function WorkorderReducer(state = initState, action) {
    switch (action.type) {
        case actions.Workorder_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
